import React from 'react';
import './css/video-container.css';
import UploadWrapper from "./UploadWrapper";

function UploadVideoContainer() {
    return (
        <div className="video-container upload-container">
            <img src="./images/icon-video.png" alt="Video"/>
            <UploadWrapper>
                <button className="btn third small">Upload my video
                </button>
            </UploadWrapper>
        </div>
    );
}

export default UploadVideoContainer;
